import { useCallback } from 'react';
import { UsersRequest } from '../../../../../store/reducers/UsersSlice';

interface Props {
  onCallRequest: (
    value: UsersRequest | ((prev: UsersRequest) => UsersRequest),
  ) => void;
}

export const useUsersFilterChanges = ({ onCallRequest }: Props) => {
  const handleClinics = useCallback(
    (e: string[]) => {
      onCallRequest((prev: UsersRequest) => ({
        ...prev,
        'Filter.ClinicIds': e,
        PageIndex: 0,
      }));
    },
    [onCallRequest],
  );

  const handleRoles = useCallback(
    (e: string[]) => {
      onCallRequest((prev: UsersRequest) => ({
        ...prev,
        'Filter.RoleIds': e,
        PageIndex: 0,
      }));
    },
    [onCallRequest],
  );

  const handleIsLockout = useCallback(
    (e: string) => {
      onCallRequest((prev: UsersRequest) => ({
        ...prev,
        'Filter.IsLockout': e,
        PageIndex: 0,
      }));
    },
    [onCallRequest],
  );

  return { handleClinics, handleRoles, handleIsLockout };
};
